<script lang="ts">
    import clsx from 'clsx';

    export let narrow = false;
    export let medium = false;
    export let wide = false;

    let classes: string;

    $: classes = clsx('mx-auto max-w-md sm:max-w-xl w-full', {
        'md:max-w-3xl': medium,
        'md:max-w-3xl lg:max-w-4xl': !narrow && !wide && !medium,
        'md:max-w-3xl lg:max-w-5xl': wide,
    });
</script>

<div class={classes}>
    <slot />
</div>
